import { render, staticRenderFns } from "./BaseInfo2.vue?vue&type=template&id=0e1191de&scoped=true&"
import script from "./BaseInfo2.vue?vue&type=script&lang=js&"
export * from "./BaseInfo2.vue?vue&type=script&lang=js&"
import style0 from "./BaseInfo2.vue?vue&type=style&index=0&id=0e1191de&prod&lang=css&"
import style1 from "./BaseInfo2.vue?vue&type=style&index=1&id=0e1191de&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e1191de",
  null
  
)

export default component.exports